import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=5aad56f0&scoped=true&"
var script = {}
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=5aad56f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad56f0",
  null
  
)

export default component.exports